import { useCallback, useState } from 'react';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { FileUploaderModal } from '@library/components/modals/FileUploaderModal';
import { SecondaryButton } from '@library/components/buttons';
import type { SerializedError } from '@reduxjs/toolkit';
import Upload from '@library/assets/images/Upload.svg';

interface PollsImageUploaderProps {
  onImageUpload: (file: File | null) => void;
  error: FetchBaseQueryError | SerializedError | undefined;
  isLoading?: boolean;
  isSuccess?: boolean;
  reset?: () => void;
}

export const PollsImageUploader = ({
  onImageUpload,
  error,
  isLoading = false,
  isSuccess = true,
  reset = () => {}
}: PollsImageUploaderProps) => {
  const [open, setOpen] = useState<boolean>(false);

  const openModal = useCallback(() => setOpen(true), []);
  const closeModal = useCallback(() => setOpen(false), []);
  const onFileUpload = useCallback(
    (file: File | null) => {
      if (!file) return;
      onImageUpload(file);
      closeModal();
    },
    [onImageUpload, closeModal]
  );

  return (
    <>
      <SecondaryButton
        handleOnClick={openModal}
        className="flex items-center justify-center gap-2 px-3 py-2 text-base font-medium"
      >
        <img src={Upload} alt="" className="h-[1.25em]" />
        Browse
      </SecondaryButton>
      <FileUploaderModal
        active={open}
        fileType="webp"
        onCancelModal={closeModal}
        onFileUpload={onFileUpload}
        isUploadError={Boolean(error)}
        isUploading={isLoading}
        isUploadSuccess={isSuccess}
        resetUploadAPI={reset}
        uploadError={error}
      />
    </>
  );
};
